import Vue from 'vue';
import socket from 'client/socket';
import config from 'client/config';

export default function(store) {
  const state = {items: [], eventId: null, error: ''};
  let revision = 0;

  function join() {
    if (!state.eventId) return;
    socket.emit('join', 'displayTimer:' + state.eventId);
    socket.emit('join', 'displayTimer.delete');
  }

  const actions = {
    'displayTimers.load': async function(ctx, {eventId}) {
      if (eventId !== state.eventId) {
        if (state.eventId) socket.emit('leave', 'displayTimer:' + state.eventId);
        store.commit('displayTimers.context', eventId);
      }
      join();
      return store.dispatch('displayTimers.reload');
    },
    'displayTimers.reload': async function() {
      const eventId = state.eventId;
      const request = ++revision;
      if (!eventId) return;
      try {
        const result = await Vue.http.get(config.root + '/events/' + encodeURIComponent(eventId) + '/displayTimers');
        if (request === revision && eventId === state.eventId) {
          store.commit('displayTimers.items', result.data);
          store.commit('displayTimers.error', '');
        }
      } catch (error) {
        if (request === revision) store.commit('displayTimers.error', error.body?.error?.message || error.message || error.statusText || String(error));
        throw error;
      }
    },
    'displayTimer.add': async function(ctx, timer) {
      const result = await Vue.http.post(config.root + '/events/' + encodeURIComponent(timer.eventId) + '/displayTimers', timer);
      await store.dispatch('displayTimers.reload');
      return result.data;
    },
    'displayTimer.control': async function(ctx, {id, action}) {
      await Vue.http.post(config.root + '/displayTimers/' + encodeURIComponent(id) + '/control', {action});
      await store.dispatch('displayTimers.reload');
    },
    'displayTimer.remove': async function(ctx, {id}) {
      await Vue.http.delete(config.root + '/displayTimers/' + encodeURIComponent(id));
      await store.dispatch('displayTimers.reload');
    },
  };

  store.registerModule('displayTimers', {
    state,
    actions,
    mutations: {
      'displayTimers.context': function(state, eventId) {
        state.eventId = eventId;
        state.items = [];
        state.error = '';
      },
      'displayTimers.items': function(state, items) { state.items = items; },
      'displayTimers.error': function(state, error) { state.error = error; },
    },
  });

  // Always fetch the latest snapshot, including after reconnects and concurrent controls.
  const reload = () => store.dispatch('displayTimers.reload').catch(() => {});
  socket.on('connect', () => { join(); reload(); });
  socket.on('displayTimer.update', ({data}) => {
    if (data.eventId === state.eventId) reload();
  });
  socket.on('displayTimer.delete', reload);
}
